var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdyen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.adyen{fill:#0ABF53;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "adyen",
    d: "M62,39.2c0,6.9,0,13.8,0,20.7c0,1.6-0.4,2.1-2,2.1c-13.7-0.1-27.3,0-41,0c-6.4,0-11-4.5-11-10.9 c0-4.1,0-8.1,0-12.2c0.1-5.8,4.7-10.4,10.4-10.4c3.3,0,6.7,0,10,0c1.3,0,1.8,0.4,1.7,1.7c-0.1,4.7,0,9.5,0,14.2 c0,3.3,1.2,4.5,4.5,4.5c5,0,5,0,5-5c0-5.9,0-11.8,0-17.7c0-4-1-5-4.9-5c-8.1,0-16.2,0-24.2,0c-1.4,0-2-0.3-1.9-1.9 c0.1-3.2,0.1-6.4,0-9.5C8.7,8.5,9,8,10.4,8C24.2,8,38,8,51.8,8c5.4,0,10.1,4.7,10.1,10.2C62,25.2,62,32.2,62,39.2 C62,39.2,62,39.2,62,39.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdyen);
export default __webpack_public_path__ + "static/media/adyen.34279626a300f4eb903b4eddf74fdf92.svg";
export { ForwardRef as ReactComponent };